import { render, staticRenderFns } from "./DigitalAccount.vue?vue&type=template&id=2e78f7a3"
import script from "./DigitalAccount.vue?vue&type=script&lang=js"
export * from "./DigitalAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports